import { useAclContext } from '../../../contexts/acl'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'
import { transactionOperations } from '../../../constants/operation'

const useBankTransactions = () => {
	const params = useParams()
	const navigate = useNavigate()
	const { permissions } = useAclContext()
	const hasWriteAccess = permissions.banking?.write

	const modalInitial = {
		action: null,
		open: false,
		transaction: null,
		type: 'banking',
	}
	const [modal, setModal] = useState(modalInitial)

	const onDetailsClicked = (transaction) => {
		if (params.tab) navigate(`/users/${params.id}/${params.tab}/${transaction._id}`)
		else navigate(`/reports/bank-transactions/${transaction._id}`)
	}

	const onOptionClicked = (idx, transaction, isManual) => {
		setModal({
			open: true,
			action: transactionOperations[idx],
			transaction,
			type: 'banking',
			isManual,
		})
	}

	const onModalClose = () => {
		if (modal.open) {
			setModal(modalInitial)
		}
	}

	const getTransactionOptions = (transaction, isManual) => {
		if (isManual && transaction.status === 'pending') {
			return ['approve', 'reject']
		}
		if (!isManual && transaction?.status === 'pending' && transaction?.flow === 'withdraw') {
			return transactionOperations
		}
		return []
	}

	return {
		hasWriteAccess,
		onDetailsClicked,
		onOptionClicked,
		modal,
		onModalClose,
		getTransactionOptions,
	}
}

export default useBankTransactions
